import { render } from "./TablaDatos.vue?vue&type=template&id=b1606fba&scoped=true"
import script from "./TablaDatos.vue?vue&type=script&lang=js"
export * from "./TablaDatos.vue?vue&type=script&lang=js"

import "./TablaDatos.vue?vue&type=style&index=0&id=b1606fba&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1606fba"]])

export default __exports__